<article class="content-page" *ngIf="theme() as theme">
  <app-theme-header [theme]="theme"></app-theme-header>

  <main *ngIf="theme?.contentBlocks?.length">
    <app-content-block-container [blocks]="theme.contentBlocks!" [theme]="theme"></app-content-block-container>
  </main>
</article>
